import PropTypes from 'prop-types';
import { Component } from 'react';
import classNames from 'classnames';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module 'bender-url!../../img/start-kno... Remove this comment to see the full error message
import imageUrl from 'bender-url!../../img/start-knowledge-base.png';
import UIButton from 'UIComponents/button/UIButton';
import UIEmptyState from 'UIComponents/empty/UIEmptyState';
import UIImage from 'UIComponents/image/UIImage';
import UIHeader from 'UIComponents/layout/UIHeader';
import UIListingPage from 'UIComponents/page/UIListingPage';
import styled from 'styled-components';
import { padding } from 'UIComponents/styles/spacing';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledStartLabel = styled.div.withConfig({
  displayName: "OnboardingStart__StyledStartLabel",
  componentId: "rnpqs4-0"
})(["", ";width:400px;"], padding('x', 5));
class OnboardingStart extends Component {
  renderDescriptionAndCta() {
    const {
      isSetupDisabled,
      onClick
    } = this.props;
    return /*#__PURE__*/_jsxs(StyledStartLabel, {
      children: [/*#__PURE__*/_jsx("h4", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.onboarding.start.title"
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "p-right-8",
        children: [/*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "knowledgeContentUI.onboarding.start.firstParagraph"
          })
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "knowledgeContentUI.onboarding.start.secondParagraph"
          })
        })]
      }), /*#__PURE__*/_jsx(UIButton, {
        className: "m-top-9",
        "data-test-id": "setup-knowledge-base",
        disabled: isSetupDisabled,
        onClick: onClick,
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.onboarding.start.button"
        })
      })]
    });
  }
  render() {
    const {
      className
    } = this.props;
    return /*#__PURE__*/_jsx(UIListingPage, {
      "data-test-id": "onboarding-start",
      className: classNames('onboarding-start', className),
      headerComponent: /*#__PURE__*/_jsx(UIHeader, {
        className: "start-page-header",
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.shared.knowledge"
        })
      }),
      children: /*#__PURE__*/_jsx(UIEmptyState, {
        maxWidth: 980,
        primaryContent: this.renderDescriptionAndCta(),
        secondaryContent: /*#__PURE__*/_jsx(UIImage, {
          src: imageUrl
        }),
        secondaryContentWidth: 400
      })
    });
  }
}
OnboardingStart.propTypes = {
  className: PropTypes.string,
  isSetupDisabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired
};
export default OnboardingStart;